module.exports = __webpack_public_path__ + "img/taylor-mobile.ebbe5340.svg";